<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.details" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh"/>
        <!--        <vxe-button content="button.addChildrenMenu" mode="text" status="primary" @click="addChildrenMenu"/>-->
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <vxe-splitter :action-config="actionConfig" border height="80vh">
        <vxe-splitter-panel name="1" width="25%">
          <template #default>
            <menu-tree ref="menuTree" @getDetail="getDetail"/>
          </template>
        </vxe-splitter-panel>
        <vxe-splitter-panel name="2">
          <template #default>
            <menu-detail ref="menuDetail"/>
          </template>
        </vxe-splitter-panel>
      </vxe-splitter>
    </vxe-card>
  </div>
</template>

<script>
import MenuTree from '@/views/config/menu/MenuTree.vue'
import MenuDetail from '@/views/config/menu/MenuDetail.vue'

export default {
  name: 'MenuMaintenance',
  components: { MenuDetail, MenuTree },
  data() {
    return {
      treeData: [],
      treeList: [],
      selectedKeys: [],
      spinning: false,
      actionConfig: {
        showPrevButton: true,
        showNextButton: true
      }
    }
  },
  created() {
    this.$nextTick(() => this.refresh())
  },
  methods: {
    getDetail(id) {
      this.$refs.menuDetail.fetch(id)
    },
    //增加子菜单
    addChildrenMenu() {
      // this.$refs.menuTree.getSelectedKey()
    },
    sendSelectedKey(selectedKey) {
      this.$refs.menuDetail.addChildMenu(selectedKey)
    },
    refresh() {
      this.$refs.menuTree.refresh()
      this.$refs.menuDetail.refresh()
    },
    save() {
      this.$sign({
        reason: '菜单维护保存',
        button: 'save',
        router: this.$route,
        click: () => {
          this.$refs.menuDetail.save()
        }
      })
    }
  }
}
</script>